import { render, staticRenderFns } from "./OldLandAreaList.vue?vue&type=template&id=9a55a742&scoped=true&"
import script from "./OldLandAreaList.vue?vue&type=script&lang=js&"
export * from "./OldLandAreaList.vue?vue&type=script&lang=js&"
import style0 from "./OldLandAreaList.vue?vue&type=style&index=0&id=9a55a742&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a55a742",
  null
  
)

export default component.exports